const CookibotFieldMapping = new Map([
  ["analytics", "statistics"],
  ["marketing", "marketing"],
  ["preferences", "preferences"],
]);

export const mapCookieConsent = category => {
  if (process.env.COOKIE_CONSENT_ENABLED === "false" || !category) {
    return "ignore";
  }
  return category
    .split(",")
    .map(cat => CookibotFieldMapping.get(cat) || cat)
    .join(",");
};

export const scriptType = () => {
  if (process.env.COOKIE_CONSENT_SCRIPT_TYPE === "text/plain") {
    return "text/plain";
  }
  return "text/javascript";
};
